export default __webpack_public_path__ + "static/media/high-school-1.c0a07e83.jpg";